/**
 * Thrown by `IApiClient.send` when the caller aborted the request through its `signal`. Unlike an `HttpError`,
 * it reports no failure: the caller asked for the request to stop, so there is usually nothing to handle.
 */
export class HttpAbortedError extends Error {
  constructor() {
    super('The request was aborted');

    // According to https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, HttpAbortedError.prototype);
  }
}
